/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PromptRecommendationDetailItem {
    getFixupPrototypeFunction() { return PromptRecommendationDetailItem.fixupPrototype; }

    static newInstance(model: Partial<PromptRecommendationDetailItem>): PromptRecommendationDetailItem {
        let obj = Object.assign(new PromptRecommendationDetailItem(), model);
        PromptRecommendationDetailItem.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PromptRecommendationDetailItem>): PromptRecommendationDetailItem {
        if (!model) return null;
        return PromptRecommendationDetailItem.newInstance(<PromptRecommendationDetailItem> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PromptRecommendationDetailItem) {
        if (!obj) return;

        models.PromptRecommendationDetailItem.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PromptRecommendationDetailItem): boolean {
        Object.setPrototypeOf(obj, PromptRecommendationDetailItem.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cost_saved === undefined) {
            this.cost_saved = 0;
        }
        if (typeof this.invoked_at === "string") {
            this.invoked_at = new Date(<string><any>this.invoked_at);
        }
        if (this.current_sku_details) {
            models.PromptSkuDetails.fixupPrototype(this.current_sku_details);
        }
        if (this.recommended_sku_details) {
            models.PromptSkuDetails.fixupPrototype(this.recommended_sku_details);
        }
    }

    /**
     * Unique prompt identifier
     */
    prompt_id: string;

    /**
     * Prompt which has been invoked
     */
    prompt: string;

    /**
     * SHA hash of the prompt text
     */
    prompt_sha: string;

    /**
     * When the prompt was invoked
     */
    invoked_at: Date;

    /**
     * Recommendation category
     */
    category: string;

    /**
     * Recommended model identifier
     */
    recommended_sku: string;

    /**
     * Saving type: UnitRate
     */
    saving_source: string;

    /**
     * Per-prompt cost saving in USD
     */
    cost_saved: number;

    /**
     * Classification confidence
     */
    confidence_tag: models.ScheduleRecommendationUtilization;

    /**
     * True if prompt is near a tier boundary
     */
    boundary: boolean;

    /**
     * Prefix of the prompt text that would be cached (caching category only); empty string for model_switching
     */
    cached_prompt: string;

    /**
     * Current model quality metrics
     */
    current_sku_details: models.PromptSkuDetails;

    /**
     * Recommended model quality metrics
     */
    recommended_sku_details: models.PromptSkuDetails;

}
